(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    (function () {
    function initMenuDrawers() {
      document.querySelectorAll('.menu__mobile-trigger').forEach(function (trigger) {
        if (trigger.dataset.drawerInit) return;
        trigger.dataset.drawerInit = '1';

        var drawerId = trigger.getAttribute('aria-controls');
        var drawer = document.getElementById(drawerId);
        if (!drawer) return;

        var wrapper = trigger.closest('.menu__mobile-drawer-wrapper');
        var overlay = wrapper ? wrapper.querySelector('.menu__mobile-drawer__overlay') : null;
        var closeBtn = drawer.querySelector('.menu__mobile-drawer__close');

        function openDrawer() {
          drawer.setAttribute('aria-hidden', 'false');
          trigger.setAttribute('aria-expanded', 'true');
          if (overlay) overlay.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }

        function closeDrawer() {
          drawer.setAttribute('aria-hidden', 'true');
          trigger.setAttribute('aria-expanded', 'false');
          if (overlay) overlay.classList.remove('is-active');
          document.body.style.overflow = '';
        }

        trigger.addEventListener('click', function () {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          isOpen ? closeDrawer() : openDrawer();
        });

        if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
        if (overlay) overlay.addEventListener('click', closeDrawer);

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
            closeDrawer();
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMenuDrawers);
    } else {
      initMenuDrawers();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
